import styled from 'styled-components';
import { device } from '../../styles/Responsive';
import {
  PrimaryColour,
  SecondaryBorderColor,
  ThirdColour,
  AlertColour,
  SuccessColour
} from '../../styles/Colours';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: ${ThirdColour};
`;

export const Card = styled.div`
  max-width: 560px;
  width: 100%;
  background: #ffffff;
  border: 1px solid ${SecondaryBorderColor};
  border-radius: 4px;
  padding: 40px;
  text-align: center;
  font-family: 'Titillium Web', sans-serif;

  @media ${device.mobileL} {
    padding: 25px 20px;
  }
`;

export const Logo = styled.img`
  width: 160px;
  margin-bottom: 30px;
`;

export const Title = styled.div`
  color: ${SecondaryBorderColor};
  font-size: 26px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 15px;

  @media ${device.mobileL} {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const Message = styled.div`
  color: #4d4d4d;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 25px;

  @media ${device.mobileL} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Details = styled.div`
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 18px 0;
  margin-bottom: 25px;
  text-align: left;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
  font-size: 15px;
  line-height: 26px;
  color: #4d4d4d;

  @media ${device.mobileL} {
    font-size: 13px;
  }
`;

export const DetailLabel = styled.span`
  color: ${PrimaryColour};
  font-weight: 600;
  white-space: nowrap;
`;

export const DetailValue = styled.span`
  text-align: right;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 25px;
`;

// Variantes como componentes próprios, e não como props: o styled-components 4 encaminha
// props desconhecidas para o DOM e o React avisaria sobre atributos inválidos no <button>
export const ActionButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  border-radius: 4px;
  font-family: 'Titillium Web', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
  border: 1px solid ${PrimaryColour};
  background: ${PrimaryColour};
  color: #ffffff;

  &:hover {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const DangerButton = styled(ActionButton)`
  background: ${AlertColour};
  border-color: ${AlertColour};
`;

export const SecondaryButton = styled(ActionButton)`
  background: transparent;
  color: ${PrimaryColour};
  border-color: ${PrimaryColour};
`;

export const SuccessIcon = styled.div`
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  color: ${SuccessColour};
`;

export const PlatformLink = styled.a`
  display: inline-block;
  color: ${PrimaryColour};
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    color: ${SecondaryBorderColor};
  }
`;
